import './assets/stylesheets/application.css';
import 'font-awesome/css/font-awesome.min.css';

const createHistory = require('history').createBrowserHistory;

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Application from './Application';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './constants/styling/themes';

import thunk from 'redux-thunk';
import reducers from './reducers';
require('es6-promise').polyfill();

const history = createHistory();

let store = createStore(
    reducers,
    (process.env.REACT_APP_CKP_ENV === 'local' &&
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__()) ||
        {},
    applyMiddleware(routerMiddleware(history), thunk)
);
ReactDOM.render(
    <Provider store={store}>
        <MuiThemeProvider theme={theme()}>
            <Application history={history} />
        </MuiThemeProvider>
    </Provider>,
    document.getElementById('ckp-application')
);
